module.exports = __webpack_public_path__ + "static/media/MaoHome.53036dcf.svg";